import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { DownloadIcon } from './Icons';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      background: scrolled ? 'rgba(15, 15, 26, 0.92)' : 'transparent',
      backdropFilter: scrolled ? 'blur(16px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(139, 92, 246, 0.12)' : '1px solid transparent',
      transition: 'all 0.3s ease',
    }}>
      <div className="container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '14px 24px',
      }}>
        <Link to="/" style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          color: '#fff',
          fontWeight: 700,
          fontSize: '1.2rem',
          gap: '10px',
        }}>
          <img
            src="/app-icon.png"
            alt="AI Vision"
            style={{ width: '36px', height: '36px', borderRadius: '8px' }}
          />
          AI Vision
        </Link>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="mobile-menu-btn"
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {menuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </>
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>

        <nav className={`nav-links ${menuOpen ? 'nav-open' : ''}`}>
          <ul style={{
            display: 'flex',
            listStyle: 'none',
            gap: '4px',
            margin: 0,
            padding: 0,
            alignItems: 'center',
          }}>
            {[
              { path: '/', label: 'Home' },
              { path: '/support', label: 'Support' },
              { path: '/privacy', label: 'Privacy' },
              { path: '/terms', label: 'Terms' },
            ].map(({ path, label }) => (
              <li key={path}>
                <Link to={path} style={{
                  textDecoration: 'none',
                  color: isActive(path) ? '#8B5CF6' : '#94A3B8',
                  fontWeight: isActive(path) ? 600 : 500,
                  fontSize: '0.92rem',
                  padding: '8px 14px',
                  borderRadius: '8px',
                  transition: 'all 0.2s ease',
                  background: isActive(path) ? 'rgba(108, 58, 237, 0.1)' : 'transparent',
                  display: 'block',
                }}>
                  {label}
                </Link>
              </li>
            ))}
            <li style={{ marginLeft: '8px' }}>
              <a
                href="https://apps.apple.com/us/app/ai-vision-objects-identifier/id6752822635"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
                style={{ padding: '8px 18px', fontSize: '0.88rem', gap: '6px' }}
              >
                <DownloadIcon size={16} />
                Download
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <style>{`
        .mobile-menu-btn {
          display: none !important;
          background: none;
          border: none;
          color: #fff;
          cursor: pointer;
          padding: 4px;
        }
        @media (max-width: 768px) {
          .mobile-menu-btn { display: flex !important; }
          .nav-links {
            position: fixed;
            top: 65px;
            left: 0;
            right: 0;
            background: rgba(15, 15, 26, 0.98);
            backdrop-filter: blur(16px);
            padding: 12px 24px 20px;
            border-bottom: 1px solid rgba(139, 92, 246, 0.12);
            transform: translateY(-120%);
            transition: transform 0.3s ease;
          }
          .nav-links.nav-open {
            transform: translateY(0);
          }
          .nav-links ul {
            flex-direction: column !important;
            gap: 2px !important;
          }
          .nav-links li { width: 100%; margin-left: 0 !important; }
          .nav-links a { width: 100%; }
        }
      `}</style>
    </header>
  );
};

export default Header;
